import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerSegunId(rut_usuario, callback: Function) {
    const inputParams = {
      entidad: {
        rut_usuario,
      }
    }

    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: usuarioInputType) {
          usuario {
            obtenerSegunId(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rut_usuario
                login
                fecha_creacion
                fecha_modificacion
                mail
                activo
                nombre_completo
                flag_cambioclave
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.usuario.obtenerSegunId
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerUsuariosxEmpresa(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($rut_empresa:Decimal, $roles_codigo:[Decimal], $sucursal_codigo:[Decimal], $entidad:usuarioInputType){
          usuario{
            obtenerSegunFiltroUsuarioxEmpresa(rut_empresa:$rut_empresa,roles_codigo:$roles_codigo,
              sucursal_codigo:$sucursal_codigo,filtro:{
              exacto:$entidad
            })
            {
              respuesta
              {
                registros
                {
                  rut_usuario
                  login
                  fecha_creacion
                  fecha_modificacion
                  mail
                  activo
                  nombre_completo
                  flag_cambioclave
                  rol_nombre
                  max_conexiones_concurrentes
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.usuario.obtenerSegunFiltroUsuarioxEmpresa
        callback({ mensajes, respuesta })
      }
    );
  }

  validarUsuario(rut_empresa, sucursal_codigo, rut_usuario, callback: Function) {
    const inputParams = {
      entidad: {
        rut_empresa,
        sucursal_codigo,
        rut_usuario,
      }
    }

    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: sucursal_usuarioInputType) {
          usuario {
            validarUsuario(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rut_usuario
                nombre_completo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.usuario.validarUsuario
        callback({ mensajes, respuesta })
      }
    );
  }

}
